export default __webpack_public_path__ + "static/media/introduction-to-industry-40-training.3d989b8c.svg";